var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outer",staticClass:"split-pane-wrapper"},[_c('div',{staticClass:"pane pane-left",style:({
      width: _vm.leftOffsetPercent,
      paddingRight: ((this.triggerWidth / 2) + "px")
    })},[_vm._t("left")],2),_c('div',{staticClass:"pane-trigger-con",style:({ left: _vm.triggerLeft, width: (_vm.triggerWidth + "px") }),on:{"mousedown":_vm.handleMousedown}}),_c('div',{staticClass:"pane pane-right",style:({
      left: _vm.leftOffsetPercent,
      paddingLeft: ((this.triggerWidth / 2) + "px")
    })},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }